angular.module('myApp.directives')
    .directive('audioVideoResponse', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs, socket) {
            },
            controller: function ($scope, $element, $attrs, $transclude, audioVideoResponse, userMediaStream, clientTools,
                                  $timeout, speechRecognitionManager, recordMediaStream, audioSensitivity, audioVideoResponseWindowMobile) {
                var qId                         = $attrs.qid;
                var defaultResponseType         = audioVideoResponse.typeText;
                if ($scope.isAVResponseEnabled) {
                    defaultResponseType = $attrs.audioVideoResponse;
                }
                $scope.responseType             = defaultResponseType;
                var avOptions = {};
                try {
                    avOptions = JSON.parse($attrs.avOptions);
                } catch (e) {
                    console.log("JSON parse error ", $attrs.avOptions);
                }
                $scope.avOptions                = avOptions;
                $scope.recordingStatus          = audioVideoResponse.recordNotActive;
                $scope.sendFileProgress         = recordMediaStream.sendFileStatuses.inactive;
                $scope.speechRecognitionStatus  = speechRecognitionManager.statuses.done;
                $scope.isAudioProblem           = false;
                $scope.isShowUiBtnTextarea      = false;
                recordMediaStream.setRecordTime(avOptions.audioVideoDurationMax, avOptions.audioVideoDurationMin);
                if ($scope.isAVResponseEnabled) {
                    $scope.recordedFiles        = null;
                    var nextBtn                 = $(".page-buttons-block");
                    var submitBtn               = $("#form_submit");
                    var videoCaptureInput       = [];
                    var startCaptureUserMedia   = function() {
                        if (!$scope.hasSupportGetUserMedia && audioVideoResponse.getType(qId) != audioVideoResponse.typeText) {
                            videoCaptureInput.trigger("click");
                            recordMediaStream.setRecordingStatus(qId, audioVideoResponse.recordActive);
                        }
                    };
                    var sendCapturedVideoAudio  = function(event) {
                        if (!$scope.hasSupportGetUserMedia) {
                            recordMediaStream.stopRecording(qId);
                            recordMediaStream.sendFileOrBlob(event.target.files[0], audioVideoResponse.getType(qId), qId);
                        }
                    };
                    var initVideoInput = function() {
                        if (!videoCaptureInput.length) {
                            videoCaptureInput = $element.find("input.captureVideo");
                            if (videoCaptureInput.length) {
                                videoCaptureInput.on("change", sendCapturedVideoAudio);
                            }
                        }
                    };
                    initVideoInput();
                    var hideShowNextBtn     = function(isShow) {
                        isShow = !!isShow;
                        if (isShow) {
                            nextBtn.show();
                        } else {
                            nextBtn.hide();
                        }
                    };

                    // Just for testing
                    /*$element.find('.testVideo').on("change", function (event) {
                        audioVideoResponse.setType(qId, audioVideoResponse.typeVideo);
                        recordMediaStream.stopRecording(qId);
                        recordMediaStream.sendFileOrBlob(event.target.files[0], 'video', qId);
                    });*/

                    let mobileRadioChangeHandler = function ($checkbox, isManualCall) {
                        let type = $checkbox.val();

                        $timeout(function () {
                            $scope.responseType = type;
                        }, 1);

                        recordMediaStream.resetRecorders(qId);

                        if (type != audioVideoResponse.typeText) {

                            if (isManualCall) {
                                $timeout(function () {
                                    // remove highlighting
                                    $checkbox.closest('.video_mic_radio').find('label').removeClass('ui-radio-on');
                                }, 1);
                            }

                            if ($scope.hasSupportGetUserMedia) {
                                //Open audio/video response window
                                audioVideoResponseWindowMobile.setAVOptions(avOptions);
                                $scope.setAudioVideoQId(qId);
                            } else {
                                audioVideoResponse.setType(qId, audioVideoResponse.typeVideo, $scope);
                                startCaptureUserMedia();
                            }
                        } else {
                            audioVideoResponse.setType(qId, audioVideoResponse.typeText, $scope);
                            $scope.setAudioVideoQId(null);
                        }

                        if (isManualCall === true && $scope.avOptions.avUI == 'av_ui_buttons' && type == audioVideoResponse.typeText) {
                            $scope.isShowUiBtnTextarea = true;
                        }
                    };

                    let isAvailableResponseTextarea = function () {
                        return $scope.isShowUiBtnTextarea;
                    };

                    if (!clientTools.isMobileLayout()) {
                        $scope.$on("recordingStatusChanged", function (e, data) {
                            if (data && ('qId' in data) && data.qId == qId) {
                                $scope.recordingStatus = recordMediaStream.getRecordingStatus(qId);
                                if ($scope.recordingStatus == audioVideoResponse.recordActive) {
                                    hideShowNextBtn(false);
                                } else if ($scope.recordingStatus == audioVideoResponse.recordNotActive) {
                                    hideShowNextBtn(false);
                                    $scope.recordedFiles = null;
                                }
                            }
                        });
                    } else {
                        $(videoCaptureInput.parents("div").get(0)).height("0px");
                        if ($scope.hasSupportGetUserMedia) {
                            videoCaptureInput.hide();
                        }
                        var widget = $element.find("input:radio");
                        widget.checkboxradio().on("change", function () {
                            mobileRadioChangeHandler($(this), true);
                        });
                        var textType    = $(widget.get(1));
                        var avType   = $(widget.get(0));
                        $scope.$watch("audioVideoQId", function(curr, prev) {
                            if (prev && !curr) {
                                var recordedFiles = recordMediaStream.getRecordedFiles(qId);
                                if (!recordedFiles.video.length && !recordedFiles.audio.length) {
                                    avType.prop("checked", false).checkboxradio("refresh");
                                    textType.prop("checked", isAvailableResponseTextarea()).checkboxradio("refresh");
                                    mobileRadioChangeHandler(textType);
                                    nextBtn.show();
                                } else {
                                    submitBtn.trigger("click");
                                    nextBtn.hide();
                                }
                            }
                        });
                    }
                    $scope.changeResponseType = function (type, isShowUiBtnTextarea) {
                        $scope.recordingStatus          = audioVideoResponse.recordNotActive;
                        $scope.sendFileProgress         = recordMediaStream.sendFileStatuses.inactive;
                        $scope.speechRecognitionStatus  = speechRecognitionManager.statuses.done;
                        $scope.isAudioProblem           = false;
                        if (!clientTools.isMobileLayout()) {
                            $scope.responseType = type;
                            recordMediaStream.resetRecorders(qId);
                            if (type == audioVideoResponse.typeText) {
                                audioVideoResponse.setType(qId, type);
                                hideShowNextBtn(true);
                            } else {
                                hideShowNextBtn(false);
                                if (!$scope.hasSupportGetUserMedia) {
                                    initVideoInput();
                                    audioVideoResponse.setType(qId, audioVideoResponse.typeVideo);
                                    startCaptureUserMedia();
                                }
                            }
                        } else {
                            if (type == audioVideoResponse.typeText) {
                                avType.prop("checked", false).checkboxradio("refresh");
                                textType.prop("checked", isAvailableResponseTextarea()).checkboxradio("refresh");
                                mobileRadioChangeHandler(textType);

                                if (!$scope.hasSupportGetUserMedia) {
                                    audioVideoResponse.setType(qId, type);
                                    hideShowNextBtn(true);
                                }
                            } else {
                                textType.prop("checked", false).checkboxradio("refresh");
                                avType.prop("checked", false).checkboxradio("refresh");
                                mobileRadioChangeHandler(avType);
                            }
                        }

                        if (isShowUiBtnTextarea === true) {
                            $scope.isShowUiBtnTextarea = isShowUiBtnTextarea;
                        }
                    };

                    $scope.$on("recordedFilesProgress", function (e, data) {
                        if (data && ('qId' in data) && data.qId == qId && ('status' in data)) {
                            $timeout(function () {
                                var status = data.status;
                                $scope.sendFileProgress = status;
                                if (recordMediaStream.getRecordingStatus(qId) === audioVideoResponse.recordStopped) {
                                    if (status === recordMediaStream.sendFileStatuses.done) {
                                        try {
                                            hideShowNextBtn(true);
                                            $scope.recordedFiles = JSON.stringify(recordMediaStream.getRecordedFiles(qId));
                                            //console.log($scope.recordedFiles);
                                        } catch (e) {
                                        }
                                    } else if (status === recordMediaStream.sendFileStatuses.failed && $scope.isAudioProblem) {
                                        hideShowNextBtn(false);
                                    }
                                }
                            }, 1);
                        }
                    });
                    $scope.$on("speechRecognitionStatus", function (e, data) {
                        if (data && ('qId' in data) && data.qId == qId && ('status' in data)) {
                            $scope.speechRecognitionStatus = data.status;
                        }
                    });

                    $scope.$on("audioCheckStatus", function (e, data) {
                        if (data && ('qId' in data) && data.qId == qId) {
                            if (data.status < audioSensitivity.statuses.ok) {
                                $scope.isAudioProblem = true;
                            } else {
                                $scope.isAudioProblem = false;
                            }
                        }
                    });

                    $scope.isDefaultTypeInited = false;
                    $scope.setDefaultResponseType = function () {
                        $scope.isDefaultTypeInited = true;
                        if ($scope.hasSupportGetUserMedia) {
                            navigator.mediaDevices.enumerateDevices()
                                .then(function(deviceInfo) {
                                    userMediaStream.setDevices(deviceInfo);
                                    $scope.changeResponseType($attrs.audioVideoResponse);
                                })
                                .catch(userMediaStream.setUserMediaError);
                        } else {
                            $scope.changeResponseType($attrs.audioVideoResponse);
                        }
                    };
                    if ($attrs.hasThumb === '0') {
                        $scope.setDefaultResponseType();
                    }
                    $scope.isAnyDevicesPresent = function () {
                        if (!$scope.hasSupportGetUserMedia) {
                            return true;
                        }
                        var devices = userMediaStream.getDevices();
                        /*if (clientTools.isMobileLayout() && $scope.hasSupportGetUserMedia) {
                            $scope.responseType = audioVideoResponse.typeText;
                        }*/
                        return devices.video.length || devices.audio.length;
                    };
                }
            }
        }
    });